import { render } from "./EnvioMagicLinksEvento.vue?vue&type=template&id=4e0484b3&scoped=true"
import script from "./EnvioMagicLinksEvento.vue?vue&type=script&lang=js"
export * from "./EnvioMagicLinksEvento.vue?vue&type=script&lang=js"

import "./EnvioMagicLinksEvento.vue?vue&type=style&index=0&id=4e0484b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0484b3"]])

export default __exports__